import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Container,
  Grid,
  Typography,
  Link,
  IconButton,
  Divider,
} from "@mui/material";
import FacebookIcon from "@mui/icons-material/Facebook";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import LocationOnIcon from "@mui/icons-material/LocationOn";

const Footer = () => {
  const navigate = useNavigate();

  const companyLinks = [
    { label: "About Us", path: "/about" },
    { label: "Contact Us", path: "/contact" },
    { label: "Careers", path: "#" },
    { label: "Privacy Policy", path: "#" },
    { label: "Terms & Conditions", path: "#" },
  ];

  const resourceLinks = [
    { label: "Products", path: "/products" },
    { label: "Request Quote", path: "/request-quote" },
    { label: "Tenders", path: "/tenders" },
    { label: "Finance", path: "/finance" },
  ];

  const supportLinks = [
    { label: "Help Center", path: "#" },
    { label: "FAQs", path: "#" },
    { label: "Track Order", path: "/orders" },
    { label: "Shipping Info", path: "#" },
  ];

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: "#1a1a2e",
        color: "white",
        pt: 6,
        pb: 3,
        mt: "auto",
      }}
    >
      <Container maxWidth="xl">
        <Grid container spacing={4}>
          {/* Company Info */}
          <Grid item xs={12} md={4}>
            <Typography variant="h5" fontWeight={700} gutterBottom>
              Loha Mart
            </Typography>
            <Typography
              variant="body2"
              color="rgba(255, 255, 255, 0.7)"
              sx={{ mb: 2 }}
            >
              India's Leading B2B Raw Materials Procurement Platform
            </Typography>
            <Typography
              variant="body2"
              color="rgba(255, 255, 255, 0.7)"
              sx={{ mb: 3 }}
            >
              Empowering businesses with quality materials, competitive pricing,
              and reliable service across the nation.
            </Typography>

            {/* Social Media Icons */}
            <Box sx={{ display: "flex", gap: 1 }}>
              <IconButton
                size="small"
                component="a"
                href="https://www.facebook.com/share/1L2oqnoYTX/"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  color: "white",
                  backgroundColor: "rgba(255, 255, 255, 0.1)",
                  "&:hover": { backgroundColor: "#006efa" },
                }}
              >
                <FacebookIcon />
              </IconButton>
              <IconButton
                size="small"
                component="a"
                href="https://wa.me/918327741261"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  color: "white",
                  backgroundColor: "rgba(255, 255, 255, 0.1)",
                  "&:hover": { backgroundColor: "#25D366" },
                }}
              >
                <WhatsAppIcon />
              </IconButton>
              <IconButton
                size="small"
                sx={{
                  color: "white",
                  backgroundColor: "rgba(255, 255, 255, 0.1)",
                  "&:hover": { backgroundColor: "#006efa" },
                }}
              >
                <LinkedInIcon />
              </IconButton>
              <IconButton
                size="small"
                component="a"
                href="https://www.instagram.com/lohamartindia?igsh=dm55OXNjd3luZ3Nv"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  color: "white",
                  backgroundColor: "rgba(255, 255, 255, 0.1)",
                  "&:hover": { backgroundColor: "#E1306C" },
                }}
              >
                <InstagramIcon />
              </IconButton>
            </Box>
          </Grid>

          {/* Company Links */}
          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="h6" fontWeight={600} gutterBottom>
              Company
            </Typography>
            {companyLinks.map((link) => (
              <Link
                key={link.label}
                onClick={() => navigate(link.path)}
                sx={{
                  display: "block",
                  color: "rgba(255, 255, 255, 0.7)",
                  textDecoration: "none",
                  mb: 1,
                  cursor: "pointer",
                  "&:hover": {
                    color: "#07cdbe",
                  },
                }}
              >
                {link.label}
              </Link>
            ))}
          </Grid>

          {/* Resources Links */}
          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="h6" fontWeight={600} gutterBottom>
              Resources
            </Typography>
            {resourceLinks.map((link) => (
              <Link
                key={link.label}
                onClick={() => navigate(link.path)}
                sx={{
                  display: "block",
                  color: "rgba(255, 255, 255, 0.7)",
                  textDecoration: "none",
                  mb: 1,
                  cursor: "pointer",
                  "&:hover": {
                    color: "#07cdbe",
                  },
                }}
              >
                {link.label}
              </Link>
            ))}
          </Grid>

          {/* Support Links */}
          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="h6" fontWeight={600} gutterBottom>
              Support
            </Typography>
            {supportLinks.map((link) => (
              <Link
                key={link.label}
                onClick={() => navigate(link.path)}
                sx={{
                  display: "block",
                  color: "rgba(255, 255, 255, 0.7)",
                  textDecoration: "none",
                  mb: 1,
                  cursor: "pointer",
                  "&:hover": {
                    color: "#07cdbe",
                  },
                }}
              >
                {link.label}
              </Link>
            ))}
          </Grid>

          {/* Contact Info */}
          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="h6" fontWeight={600} gutterBottom>
              Contact Us
            </Typography>
            <Box sx={{ display: "flex", alignItems: "flex-start", mb: 1.5 }}>
              <PhoneIcon
                sx={{ fontSize: 18, mr: 1, mt: 0.5, color: "#07cdbe" }}
              />
              <Typography variant="body2" color="rgba(255, 255, 255, 0.7)">
                +91 94370 45109
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "flex-start", mb: 1.5 }}>
              <PhoneIcon
                sx={{ fontSize: 18, mr: 1, mt: 0.5, color: "#07cdbe" }}
              />
              <Typography variant="body2" color="rgba(255, 255, 255, 0.7)">
                +91 91240 75890
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "flex-start", mb: 1.5 }}>
              <EmailIcon
                sx={{ fontSize: 18, mr: 1, mt: 0.5, color: "#07cdbe" }}
              />
              <Typography variant="body2" color="rgba(255, 255, 255, 0.7)">
                info@lohamart.in
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "flex-start" }}>
              <LocationOnIcon
                sx={{ fontSize: 18, mr: 1, mt: 0.5, color: "#07cdbe" }}
              />
              <Typography variant="body2" color="rgba(255, 255, 255, 0.7)">
                S3/16, Industrial Estate Kalunga, Rourkela, Odisha 769004
              </Typography>
            </Box>
          </Grid>
        </Grid>

        <Divider sx={{ my: 3, borderColor: "rgba(255, 255, 255, 0.1)" }} />

        {/* Bottom Bar */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            alignItems: "center",
            gap: 2,
          }}
        >
          <Typography variant="body2" color="rgba(255, 255, 255, 0.5)">
            &copy; {new Date().getFullYear()} Loha Mart. All rights reserved.
          </Typography>
          <Typography variant="body2" color="rgba(255, 255, 255, 0.5)">
            Registered Office: S3/16, Industrial Estate Kalunga, Rourkela,
            Odisha 769004
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
